var React = require('react');

function CouponIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.3415 1.15L16.8415 8.65C17.1415 8.95 17.3332 9.375 17.3332 9.83333C17.3332 10.2917 17.1498 10.7083 16.8415 11.0083L11.0082 16.8417C10.7082 17.15 10.2915 17.3333 9.83317 17.3333C9.37484 17.3333 8.95817 17.15 8.65817 16.85L1.15817 9.35C0.849837 9.04166 0.666504 8.625 0.666504 8.16666V2.33333C0.666504 1.41666 1.4165 0.666664 2.33317 0.666664H8.1665C8.62484 0.666664 9.0415 0.849997 9.3415 1.15ZM2.33317 3.58333C2.33317 4.275 2.8915 4.83333 3.58317 4.83333C4.27484 4.83333 4.83317 4.275 4.83317 3.58333C4.83317 2.89166 4.27484 2.33333 3.58317 2.33333C2.8915 2.33333 2.33317 2.89166 2.33317 3.58333Z","fill":"white"}));
}

CouponIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CouponIcon;

CouponIcon.default = CouponIcon;
